<template>
    <a class="personal-project-card" :class="{ 'has-image': image }" :href="url" target="_blank">
        <div v-if="image" class="card-image">
            <img :src="image" :alt="title" loading="lazy">
        </div>
        <div v-else class="card-icon">
            <i :class="icon"></i>
        </div>
        <div class="card-body">
            <h3 class="card-title">{{ title }}</h3>
            <p class="card-description">{{ description }}</p>
            <div class="project-technologies">
                <span class="tech-tag" v-for="tech in technologies" :key="tech">
                    {{ tech }}
                </span>
            </div>
        </div>
        <div class="card-hover-overlay">
            <i :class="icon"></i>
        </div>
    </a>
</template>

<script>
export default {
    name: 'PersonalProject',
    props: {
        url: String,
        title: String,
        description: String,
        icon: String,
        image: String,
        technologies: Array
    }
}
</script>

<style scoped>
.personal-project-card {
    background: #1a1d29;
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 12px;
    padding: 35px 30px;
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
    cursor: pointer;
    display: block;
    text-decoration: none;
    color: inherit;
}

.personal-project-card::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg, #ff6b6b, #ff8787);
    transform: scaleX(0);
    transform-origin: left;
    transition: transform 0.3s ease;
}

.personal-project-card:hover {
    background: #212430;
    border-color: rgba(255, 107, 107, 0.3);
    transform: translateY(-5px);
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}

.personal-project-card:hover::before {
    transform: scaleX(1);
}

.personal-project-card.has-image {
    padding: 0;
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    max-width: 900px;
    width: 100%;
    margin: 0 auto;
}

.has-image .card-body {
    padding: 30px;
    align-self: center;
}

/* La imagen no empuja la altura de la fila: se ajusta a la del texto (mín. 220px) */
.card-image {
    position: relative;
    min-height: 220px;
    overflow: hidden;
    border-right: 1px solid rgba(255, 255, 255, 0.1);
}

.card-image img {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    transition: transform 0.4s ease;
}

.personal-project-card:hover .card-image img {
    transform: scale(1.04);
}

.has-image .card-hover-overlay {
    display: none;
}

.card-icon {
    width: 60px;
    height: 60px;
    background: rgba(255, 107, 107, 0.1);
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
    transition: all 0.3s ease;
}

.personal-project-card:hover .card-icon {
    background: rgba(255, 107, 107, 0.2);
    transform: scale(1.1);
}

.card-icon i {
    font-size: 28px;
    color: #ff6b6b;
}

.card-title {
    font-size: 22px;
    font-weight: 600;
    color: #fff;
    margin: 0 0 15px 0;
    line-height: 1.3;
}

.card-description {
    font-size: 15px;
    line-height: 1.7;
    color: rgba(255, 255, 255, 0.7);
    margin: 0 0 20px 0;
}

.project-technologies {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

.tech-tag {
    background: rgba(255, 107, 107, 0.1);
    color: #ff6b6b;
    padding: 6px 14px;
    border-radius: 6px;
    font-size: 13px;
    font-weight: 500;
    border: 1px solid rgba(255, 107, 107, 0.2);
    transition: all 0.3s ease;
}

.personal-project-card:hover .tech-tag {
    background: rgba(255, 107, 107, 0.15);
    border-color: rgba(255, 107, 107, 0.3);
}

.card-hover-overlay {
    position: absolute;
    top: -50px;
    right: -50px;
    width: 150px;
    height: 150px;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0.03;
    pointer-events: none;
}

.card-hover-overlay i {
    font-size: 120px;
    color: #fff;
}

/* Responsive */
@media (max-width: 768px) {
    .personal-project-card {
        padding: 28px 24px;
    }

    .personal-project-card.has-image {
        grid-template-columns: 1fr;
    }

    .card-image {
        min-height: 0;
        aspect-ratio: 1200 / 630;
        border-right: none;
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    }

    .has-image .card-body {
        padding: 24px;
    }

    .card-icon {
        width: 55px;
        height: 55px;
    }

    .card-icon i {
        font-size: 24px;
    }

    .card-title {
        font-size: 20px;
    }

    .card-description {
        font-size: 14px;
        margin-bottom: 16px;
    }

    .tech-tag {
        font-size: 12px;
        padding: 5px 12px;
    }
}
</style>
